// extracted by mini-css-extract-plugin
export default {"secondaryBtn":"SecondaryButton_secondaryBtn__ZupMr"};